import * as React from "react";
const SvgArrowLeftDownLine = props => <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="m9 13.589 8.607-8.607 1.414 1.415-8.607 8.606H18v2H7v-11h2z" /></svg>;
export default SvgArrowLeftDownLine;